<template>
<div style="display:none"> {{test}}</div>
    <!-- 1111{{  currentDescription  }} 22222222 -->
<!-- sign data is : {{ signIdentity[0].signId }}   ------ <br><br> -->
<!-- test is : {{ test.signs }} -->

    <!-- <li v-for="zodiac in activeSignProfile" v-bind:key="zodiac.signId"> -->

<div class="container">

		<!-- <div class="navSection">1 Logo 2


		</div> -->
		<div class="bodyContainer">


			<div class="bodySection">
				<div class="signNameSection"><h1>{{ activeSignProfile.signName }}</h1></div>
				<div class="contentArea">

					<ContentDescription />

				</div>

			</div>

			<div class="bodyNav">
				<div class="signItemContainerRow" :class="[activeSignProfile.family === 'Fire' ? 
				'fireBg':
				activeSignProfile.family === 'Earth'? 'earthBg' :
				activeSignProfile.family === 'Air'? 'airBg' : 
				activeSignProfile.family === 'Water'? 'waterBg' : null]">

					<!-- <div class="signDetailItem" v-on:click="loadContent('zodiac', `${activeSignProfile.signId}`)"> -->
					<div class="signDetailItem" v-on:click="`${getDefaultInfo()}`">
						<div class="signItemIcon">{{ activeSignProfile.glyphDisplayCharacter }}</div>
						<div class="signItemBtnName">About {{ activeSignProfile.signName }}</div>
					</div>

					<div class="signDetailItem" v-on:click="loadContent('element', `${activeSignProfile.signId}`)">
						<div class="signItemIcon">{{ activeSignProfile.elementDisplayCharacter }}</div>
						<div class="signItemBtnName">About {{ activeSignProfile.family }} Signs</div>
					</div>			

					<div class="signDetailItem" v-on:click="loadContent('quality', `${activeSignProfile.signId}`)">
						<div class="signItemIcon">{{ activeSignProfile.qualityDisplayCharacter }}</div>
						<div class="signItemBtnName">About {{ activeSignProfile.quality }} Signs</div>
					</div>

					<div class="signDetailItem" v-on:click="loadContent('house', `${activeSignProfile.signId}`)">
						<div class="signItemIcon">{{ activeSignProfile.houseDisplayCharacter }}</div>
						<div class="signItemBtnName">About House {{ activeSignProfile.house }}</div>
					</div>

					<div class="signDetailItem" v-on:click="loadContent('planet', `${activeSignProfile.signId}`)">
						<div class="signItemIcon">{{ activeSignProfile.planetDisplayCharacter }}</div>
						<div class="signItemBtnName">About {{ activeSignProfile.planet }} </div>
					</div>

				</div>

			</div>

		</div>


</div>

</template>

<script>
import { mapState } from 'vuex';
import ContentDescription from '@/components/views/ContentDescription.vue';

export default {
  data: () => {
    return {
		name: 'ProfileLandscapeMode',
		props: {

      }
    }
  },
	methods: { loadContent: function (detailTypeIs, detailIdIs){ 
		let detailType = detailTypeIs; 
		let detailId = detailIdIs;
		console.log('load content', detailType, detailId);
		this.$store.dispatch('getZodiacDetail', {detailType, detailId});
		},	
		getDefaultInfo: function ( ){
			let selectedProfile = this.$store.getters.filterZodiacData(this.$route.params.signId)
			console.log('methods selectedProfile is: ', selectedProfile)
			return this.$store.dispatch('getZodiacSignProfile', selectedProfile)
		},
		unknownParameter: function () {
			return this.$router.push({name:'NotFound'});
		}

  },
  computed: {
    ...mapState(['zodiacData', 'getZodiacSignProfile', 'currentSignProfile', 'activeSignProfile']),
    test() {


      let selectedProfile = this.$store.getters.filterZodiacData(this.$route.params.signId)

	
	// ORIG CONFIG
      console.log('computed selectedProfile is: ', selectedProfile)
    //     return this.$store.dispatch('getZodiacSignProfile', selectedProfile)

	let dispatchProfile;

	//NEW CONFIG
	if (selectedProfile === undefined) {
        console.log('landview reroute data to not fount page')
		// return this.unknownParameter()
      } else {
      console.log('landview computed selectedProfile is: ', selectedProfile)
         dispatchProfile = this.$store.dispatch('getZodiacSignProfile', selectedProfile)
        
		// return dispatchProfile;
        // return this.$store.dispatch('getZodiacSignProfile', selectedProfile)
      }

		return dispatchProfile, console.log( 'land default return')
        // return this.$store.dispatch('getZodiacSignProfile', selectedProfile)

    
	}
    },

    components: { ContentDescription
  }
}


</script>

<style scoped >
@font-face { 
  font-family: "BOSAstrology";
  src:url(../../assets/fonts/BOSAstrology2020.ttf) format("truetype");
 }
.BOS {
    font-family: "BOSAstrology";
    /* font-size: this.size ; */
	text-align: center;
	display: block;
}
body {
		overflow: hidden;
	}
.container {
	flex-direction:column;
	display: flex;
}
.bodyContainer {
	flex-direction:row;
	display: flex;
		/* background-color: orange; */
		/* height: 20px; */
}

.buttonTxt, a, .signDisplayName, .bodyContainer{
    color:white;
    text-shadow: -1px 0px 3px rgba(0, 0, 0, 1);
}

	.signNameSection{
		/* background-color: green; */
		height: 9vh;
		margin: 0;
		flex-grow: 1;
	}
	.signDetailSection{
		/* height: 10vh; */
		width: 30vw;
		/* background-color: yellow; */
		min-height: 5vh;
		margin: 0;
		justify-content: center;
		flex-grow: 1;
	}
	.bodySection{
		height: 85vh;
		width: 90vw;
		/* background-color: blue; */
		padding: 5px 0;
		margin: 0;
		overflow: auto;
	}
	.bodyNav {
		height: 80vh;
		width: 30vw;
		/* background-color: purple; */
		padding: 5px 0;
		margin: 0;
		flex-direction:column;
		display: flex;
		/* background-color: red; */
	}


.signItemContainerRow {
  background-color: pink;
  padding: 2px;
  margin: 0;
  justify-content: center;
  display: table;
  
            /* background: url('../../assets/img/fireBg.jpg') no-repeat center center fixed;
      -webkit-background-size: cover;
      -moz-background-size: cover;
      -o-background-size: cover;
      background-size: cover; */
}


.fireBg {
    background: url('../../assets/img/fireBg.jpg') no-repeat center center fixed;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
	background-size: cover;

}
.earthBg {
    background: url('../../assets/img/earthBg.jpg') no-repeat;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
	background-size: cover;

}
.airBg {
    background: url('../../assets/img/airBg.jpg') no-repeat center center fixed;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
	background-size: cover;

}
.waterBg {
    background: url('../../assets/img/waterBg.jpg') no-repeat center center fixed;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
	background-size: cover;

}
.signDetailItem {
  background-color: rgba(0, 0, 0, 0.6);
  /* background: unset; */
  padding: 5px;
  /* width: 100px; */
  height: 10vh;
  margin: 2px;
  color: white;
  text-align: center;
  display: flex;
  flex-direction: row;
  border: none;
  box-sizing:unset;
  cursor:pointer;
  appearance: unset;
  align-items: center;
  transition: all ease 0.5s;
}
.signDetailItem:hover{
  background-color: rgba(0, 0, 0, 0.4);
}

.signItemIcon {
    font-family: "BOSAstrology";

	padding: 10px;
	font-size: 5vh;
	line-height: 5vh;
}
.signItemBtnName {
	font-size: 2.5vh;
	padding: 5px;
	line-height: 3vh;
	text-align: left;

}
.contentArea{
	padding: 10px 20px;
}
h1 {
	text-align: center;
	font-size: 8vh;
	line-height: 8vh;
    display: block;
    /*font-size: 2em;*/
    margin-block-start: 0;
    margin-block-end: 0;
    margin-inline-start: 0;
    margin-inline-end: 0;
    font-weight: bold;
}
h2{
	display: block;
    font-size: 6vh;
    margin-block-start: 0;
    margin-block-end: 0;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
	text-align: center;
    font-weight: bold;
}
.iconDisplay{
    font-family: "BOSAstrology";
	text-align: center;
	font-size: 30vh;
	line-height: 30vh;
}


</style>